// extracted by mini-css-extract-plugin
module.exports = {"viewDownloadsModalWrapper":"rB","header":"rC","headline":"rD","closeIcon":"rE","modalCloseIcon":"rF"};